import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { ShiftResponseModel } from "@gtpl/shared-models/hrms";
import { LogsService } from "@gtpl/shared-services/user-logs";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { LogsDto } from "libs/shared-models/user-logs/src/lib/Logs/logs.dto";
import { Repository } from "typeorm";
import { UserRequestDto } from "../teams/dtos/user-request-dto";
import { ShiftReq } from "./dto/shift-req.request";
import { ShiftDto } from "./dto/shifts.dto";
import { ShiftRequest } from "./dto/shifts.request";
import { ShiftsEntity } from "./entities/shifts.entity";
import { ShiftAdapter } from "./shifts.adapter";

@Injectable()
export class ShiftService {
    constructor(
      private logService:LogsService,
        @InjectRepository(ShiftsEntity)
        private repo: Repository<ShiftsEntity>,
        private adapter: ShiftAdapter,
    ) { }

    async getShiftDetails(shift: string): Promise<ShiftsEntity> {
        const shiftResponse = await this.repo.findOne({
            where: { shift: shift }
        });
        if (shiftResponse) {
            return shiftResponse;
        } else {
            return null;
        }
    }

    async createShift(dto: ShiftDto, isUpdate: boolean): Promise<ShiftResponseModel> {
        try {
          let previousValue
            if (isUpdate) {
                const entity = await this.getShiftDetails(dto.shift);
                if (entity) {
                    throw new ErrorResponse(11104, 'Shift Already Exists');
                }
            } else {
                const entity = await this.getShiftDetails(dto.shift);
                if (entity) {
                    if (entity.shift != dto.shift) {
                        throw new ErrorResponse(11104, 'Shift Already Exists')
                    }
                }
            }
            // const previousVal = await this.repo.findOne({where:{id:dto.id}})
            // previousValue = previousVal.shift
            const shift = await this.repo.findOne({ where: { shift: dto.shift } });
            if (shift) {
                throw new ErrorResponse(11104, 'Shift Already Exists');
            }
            const convertedEntity: ShiftsEntity = this.adapter.convertDtoToEntity(dto, isUpdate);
            const savedEntity: ShiftsEntity = await this.repo.save(convertedEntity);
            const savedDto: ShiftDto = this.adapter.convertEntityToDto(savedEntity);
            if (savedDto) {
            const certificatePresent = savedDto.shift;

                const response = new ShiftResponseModel(true, 1, isUpdate ? 'Shift Updated Successfully' : 'Shift Created Successfully');
                
                const name=isUpdate?'updated':'created'
                const displayValue = isUpdate? 'Shift Updated Successfully': 'Shift Created Successfully'
                const userName = isUpdate? savedDto.updatedUser :savedDto.createdUser;
                const newLogDto = new LogsDto(1,name, 'ShiftsEntity', savedDto.id, true, displayValue,userName,previousValue,certificatePresent)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);return response;
            } else {
                throw new ErrorResponse(11106, 'Shift saved but issue while transforming it into DTO');
            }
        } catch (error) {
            throw error;
        }
    }


    async getAllShiftActions(req?:UserRequestDto): Promise<ShiftResponseModel> {
        try {
            const shtDto: ShiftDto[] = [];
            const shtEntity: ShiftsEntity[] = await this.repo.find({ order: { id: 'DESC' } });
            console.log(shtEntity)
            if (shtEntity.length) {
                shtEntity.forEach(Entity => {
                    const convertedDto: ShiftsEntity = this.adapter.convertEntityToDto(Entity);
                    shtDto.push(convertedDto);
                });
                const response=new ShiftResponseModel(true, 1, 'Shift Retrieved Successfully', shtDto);
                if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'ShiftsEntity', 0, true, 'Shift Retrieved Successfully',req.createdUser,'','')
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                }
                return response
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getAllActiveShiftActions(): Promise<ShiftResponseModel> {
        try {
            const shtDto: ShiftDto[] = [];
            const shtEntity: ShiftsEntity[] = await this.repo.find({ order: { id: 'ASC' }, where: { isActive: true }, });
            if (shtEntity) {
                shtEntity.forEach(Entity => {
                    const convertedEntity: ShiftDto = this.adapter.convertEntityToDto(Entity);
                    shtDto.push(convertedEntity);
                });
                const response = new ShiftResponseModel(true, 11108, 'Active Shift Retrieved Successfully', shtDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getShiftByShift(req: ShiftReq): Promise<ShiftResponseModel> {
        const Entity = await this.repo.findOne({
            where: { shift: req.shift },
        });
        const convertedEntity: ShiftDto = this.adapter.convertEntityToDto(Entity);
        if (convertedEntity) {
            return new ShiftResponseModel(true, 11109, 'Shift Retrieved Successfully', [convertedEntity]);
        } else {
            throw new ErrorResponse(99998, 'Data Not Found');
        }
    }

    async getShiftById(id: number): Promise<ShiftsEntity> {
        const response = await this.repo.findOne({
            where: { id: id },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateShift(shtReq: ShiftRequest): Promise<ShiftResponseModel> {
        try {
            const shtExists = await this.getShiftById(shtReq.id);
            if (shtExists) {
                if (shtReq.versionFlag != shtExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Shift information. Refresh and try again');
                } else {
                    const shtStatus = await this.repo.update(
                        { id: shtReq.id },
                        { isActive: shtReq.isActive, updatedUser: shtReq.updatedUser }
                    );
                    if (shtExists.isActive) {
                        if (shtStatus.affected) {
                            const shtResponse: ShiftResponseModel = new ShiftResponseModel(true, 10115, 'Shift is de-activated successfully');
                            return shtResponse;
                        } else {
                            throw new ErrorResponse(10111, ' Shift is already de-activated');
                        }
                    } else {
                        if (shtStatus.affected) {
                            const shtResponse: ShiftResponseModel = new ShiftResponseModel(true, 10114, 'Shift is activated successfully');
                            return shtResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Shift is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

}